import {
    type FC
} from "react";
import type {
    IEmptyDescriptionProps,
    EmptyPartContentProps
} from "../../type";
import {
    withEmptyContext
} from "../../context";
import stylesheet, {
    EMPTY_DESCRIPTION_SKELETON_LINES,
    EMPTY_DESCRIPTION_SKELETON_WIDTH
} from "../../stylesheet";
import Skeleton from "../../../skeleton";
import Text from "../../../text";

const EmptyDescriptionBase: FC<EmptyPartContentProps<IEmptyDescriptionProps>> = ({
    customTheme: customThemeProp,
    children,
    context,
    style,
    ...props
}) => {
    const customTheme = customThemeProp ?? context.customTheme;

    if(context.isLoading) {
        return <Skeleton
            typography={context.measures.descriptionVariant}
            lines={EMPTY_DESCRIPTION_SKELETON_LINES}
            width={EMPTY_DESCRIPTION_SKELETON_WIDTH}
            customTheme={customTheme}
            variant="text"
        />;
    }

    return <Text
        {...props}
        customColor={context.colors.descriptionColor}
        variant={context.measures.descriptionVariant}
        style={[
            style,
            stylesheet.description
        ]}
        customTheme={customTheme}
    >
        {children}
    </Text>;
};
export default withEmptyContext("description", EmptyDescriptionBase);
